module.exports = __webpack_public_path__ + "img/quick-prompts.svg";